import BrochureCarousel from "../components/BrochureCarousel";
import { Link } from "react-router-dom";
const brochures = [
  "/brochures/1.png",
  "/brochures/2.png",
  "/brochures/3.png",
  "/brochures/4.png",
  "/brochures/5.png",
  "/brochures/6.png",
  "/brochures/7.png",
  "/brochures/8.png",
  "/brochures/9.png",
  "/brochures/10.png",
  "/brochures/11.png",
];

export default function Brochures() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold">General Information & Brochures</h1>
        <p className="mt-4 text-gray-600">
          Official awareness and information material shared by VV Caring
          Center.
        </p>

      </div>

      <BrochureCarousel brochures={brochures} />
      <div className="flex items-center justify-center">
              <Link
                to={"/#about"}
                className="mb-5 mt-5 py-2 px-6 bg-green-600 rounded-md text-white font-poppins x font-semibold hover:bg-green-700 transition"
              >
                Back
              </Link>
            </div>
    </section>
  );
}
